import React from "react";

import Select from "../index";

export default function Job(props) {
  const items = ["queued", "executing", "finished", "retrying", "failed"];

  return <Select name="status" items={items} {...props} />;
}
